import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import * as C from "@/common";

interface ITokenPayload extends C.IUserInfo {
	/** Issued At Time */
	iat: number;
	/** Not Before Time */
	nbf: number;
	/** Expiration time */
	exp: number;
	/** Issuer */
	iss: string;
	/** Audience */
	aud: string;
}

Vue.use(Vuex);
export interface IRootState {
	locale: C.Language;
	token?: string;
	user?: C.IUserInfo;
}

const vuexLocal = new VuexPersistence<IRootState>({
	storage: window.localStorage,
  });
export default new Vuex.Store({

	strict: process.env.NODE_ENV !== "production",

	state: {
		locale: "de",
	} as IRootState,
	mutations: {
		setLocale: (state, lang: C.Language) => {
			state.locale = lang;
		},
		switchLocale: (state) => {
			state.locale = state.locale === "de" ? "en" : "de";
		},
		setToken: (state, t?: string) => {
			let user: C.IUserInfo | null = null;
			if (t) {
				state.token = t;
				const parts = t.split(".");
				if (parts && parts.length === 3) {
					const p = JSON.parse(atob(parts[1])) as ITokenPayload;

					user = {
						admin: p.admin,
						avatar: p.avatar,
						nickname: p.nickname,
						orig: p.orig,
						locale: p.locale,
					};
				}
			}
			state.user = user || undefined;
		},
		signout: (state) => {
			state.user = undefined;
			state.token = undefined;
		},
	},
	actions: {

	},
	plugins: [
		vuexLocal.plugin,
	],
});
